import { createFileRoute, notFound } from "@tanstack/react-router";
import { MuranoLeksikonArticlePage } from "@/pages/MuranoLeksikonPage";
import { getLeksikonArticle } from "@/lib/murano-leksikon";
import { buildLeksikonHead } from "./murano.leksikon.$slug";

export const Route = createFileRoute("/en/murano/leksikon/$slug")({
  loader: ({ params }) => {
    const article = getLeksikonArticle(params.slug);
    if (!article) throw notFound();
    return { article };
  },
  head: ({ params }) => buildLeksikonHead(params?.slug, "en"),
  component: () => {
    const { article } = Route.useLoaderData();
    return <MuranoLeksikonArticlePage article={article} locale="en" />;
  },
  notFoundComponent: () => (
    <div className="mx-auto max-w-2xl px-6 pt-40 pb-32 text-center">
      <p className="eyebrow">404</p>
      <h1 className="mt-4 font-display text-5xl">Article not found</h1>
      <a
        href="/en/murano/leksikon"
        className="mt-8 inline-flex items-center gap-2 rounded-full bg-foreground px-6 py-3 text-xs font-medium uppercase tracking-[0.22em] text-background"
      >
        To the encyclopedia →
      </a>
    </div>
  ),
});
